import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { initializeApp, provideFirebaseApp, FirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, provideAppCheck } from '@angular/fire/app-check';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getPerformance, providePerformance } from '@angular/fire/performance';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getSpanishPaginatorIntl } from './shared/utils/spanish-paginator-intl';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

declare global {
    var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | undefined;
}

if(!environment.production) {
	self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

export const MY_DATE_FORMATS = {
	parse: {
		dateInput: 'DD/MM/YYYY',
	},
	display: {
		dateInput: 'DD/MM/YYYY',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideFirebaseApp(() => initializeApp(environment.firebase)),
		provideAuth(() => getAuth()),
		provideAnalytics(() => getAnalytics()),
		ScreenTrackingService,
		UserTrackingService,
		provideAppCheck((injector) => {
			const firebaseApp = injector.get(FirebaseApp);
			const provider    = new ReCaptchaEnterpriseProvider(environment.appCheck.siteKey);

  			return initializeAppCheck(firebaseApp, { provider, isTokenAutoRefreshEnabled: true });
		}),
		provideFirestore(() => getFirestore()),
		provideFunctions(() => getFunctions()),
		providePerformance(() => getPerformance()),
		provideStorage(() => getStorage()),
		{ provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl() },
		{ provide: MAT_DATE_LOCALE, useValue: 'es-GT' },
		{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
	]
};
